import React from "react";
import { Grid, Paper, Typography } from "@mui/material";
import { themes } from "services/constants";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { useDispatch } from "react-redux";
import {
  PersonOff,
  EventNote,
  ViewModule,
  Pool,
  AssignmentTurnedIn,
} from "@mui/icons-material";

// Configuration/Assignment second-level pattern (QW-16), matching the
// group mechanism used in Shift and Salary Configuration's menuItems.
const leaveMenuItems = [
  {
    type: "title",
    title: "Configuration",
  },
  {
    type: "item",
    title: "Leave Year",
    key: "Leave Year",
    icon: <EventNote sx={{ fontSize: 20 }} />,
  },
  {
    type: "item",
    title: "Leave Type",
    key: "Leave Type",
    icon: <ViewModule sx={{ fontSize: 20 }} />,
  },
  {
    type: "item",
    title: "Leave Group",
    key: "Leave Group",
    icon: <PersonOff sx={{ fontSize: 20 }} />,
  },
  {
    type: "item",
    title: "Holidays",
    key: "Holidays",
    icon: <Pool sx={{ fontSize: 20 }} />,
  },
  {
    type: "title",
    title: "Assignment",
  },
  {
    type: "item",
    // Display label only. The underlying key stays "Assignment" — it is
    // the LMS sub-module name used by checkEditorPermission() and by
    // currentScreen in TimeOffSettings/index.js.
    title: "Assign Leave Group",
    key: "Assignment",
    icon: <AssignmentTurnedIn sx={{ fontSize: 20 }} />,
  },
];

export const SettingsMenu = ({ setCurrentScreen, currentScreen }) => {
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <Grid
        conatiner
        spacing={2}
        sx={{
          marginTop: 2,
          height: "92.5vh",
          overflow: "hidden",
          backgroundColor: themes.primary,
        }}
        component={Paper}
        elevation={3}
      >
        {leaveMenuItems.map((item, index) =>
          item.type === "title" ? (
            <Grid item key={`title-${index}`} sx={{ padding: 1 }}>
              <Typography
                sx={{ fontWeight: 700, color: "#00D4AA", fontSize: 14 }}
              >
                {item.title}
              </Typography>
            </Grid>
          ) : (
            <Grid item key={item.key} sx={{ padding: 0.5 }}>
              <Paper
                elevation={currentScreen === item.key ? 1 : 0}
                sx={{
                  cursor: "pointer",
                  color: themes.headLine,
                  backgroundColor:
                    currentScreen === item.key
                      ? themes.whiteColor
                      : themes.primary,
                }}
                onClick={() => {
                  dispatch(setGlobalSearchValue(""));
                  localStorage.setItem("settingScreens", item.key);
                  setCurrentScreen(item.key);
                }}
              >
                <Typography sx={{ padding: 1.5, fontSize: 17 }}>
                  {item.icon} {item.title}
                </Typography>
              </Paper>
            </Grid>
          ),
        )}
      </Grid>
    </React.Fragment>
  );
};
